module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "contentWrapper",
    staticClass: "el-switch",
    class: [{
      'is-disabled': _vm.switchDisabled,
      'is-checked': _vm.checked
    }],
    style: (_vm.rtBaseSwitchWrapperStyle),
    attrs: {
      "aria-checked": _vm.checked,
      "aria-disabled": _vm.switchDisabled
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.switchValue.apply(null, arguments)
      }
    }
  }, [_c('input', {
    ref: "input",
    staticClass: "el-switch__input",
    attrs: {
      "id": _vm.id,
      "type": "checkbox",
      "name": _vm.name,
      "true-value": _vm.activeValue,
      "false-value": _vm.inactiveValue,
      "disabled": _vm.switchDisabled
    },
    on: {
      "change": _vm.handleChange,
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.switchValue.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "el-switch__core",
    class: ['content-wrapper', _vm.isAnimationFinished && 'content-wrapper-animation', 'rt-switch-' + _vm.size],
    style: ({
      'width': _vm.coreWidth + 'px',
      left: _vm.contentWrapperLeft
    })
  }, [_c('div', {
    staticClass: "active-wrapper",
    style: ({
      width: _vm.computedActiveTextWidth + 'px'
    })
  }, [_c('span', {
    ref: "activeText",
    staticClass: "active-text"
  }, [_vm._v(_vm._s(_vm.activeText))])]), _vm._v(" "), _c('div', {
    staticClass: "circle",
    style: (_vm.circleStyle)
  }, [(_vm.computedIconName) ? _c('rt-icon', {
    attrs: {
      "name": _vm.computedIconName,
      "color": _vm.computedIconColor
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "inactive-wrapper",
    style: ({
      width: _vm.computedInactiveTextWidth + 'px'
    })
  }, [_c('span', {
    ref: "inactiveText",
    staticClass: "inactive-text"
  }, [_vm._v(_vm._s(_vm.inactiveText))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64b0470a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/element-ui/packages/switch/src/component.vue
// module id = 2165
// module chunks = 137